import { isUploadFileResponseError } from "common/components/types";
import { uploadFileIntoGlideStorage } from "common/components/upload-handlers";
import { getFeatureSetting } from "common/feature-settings";
import type { AddToMediaLibraryBody } from "common/firebase-function-types";
import { getAppFacilities } from "webapp/lib/app-renderer";

export async function handleFileUpload(file: File, appID: string): Promise<string | undefined> {
    const session = uploadFileIntoGlideStorage(getAppFacilities(), appID, file, "data-editor", undefined);
    const uploadResponse = await session.attempt();
    if (!isUploadFileResponseError(uploadResponse)) {
        if (getFeatureSetting("mediaLibrary")) {
            // FIXME: Actually report these errors
            const body: AddToMediaLibraryBody = {
                kind: "image",
                url: uploadResponse.path,
                name: file.name,
            };
            await getAppFacilities().callAuthCloudFunction("addToMediaLibrary", body);
        }

        return uploadResponse.path;
    }

    return undefined;
}
